import { Component, OnInit } from '@angular/core';
import { RoutineService } from 'src/app/services/routine.service';

@Component({
  selector: 'app-automatic-routines-list-tablet',
  templateUrl: './automatic-routines-list-tablet.component.html',
  styleUrls: ['./automatic-routines-list-tablet.component.scss'],
})
export class AutomaticRoutinesListTabletComponent implements OnInit {
  constructor(private routineService: RoutineService) {}

  ngOnInit(): void {}
}
